export class ApiCollection {
    static SIGN_IN: String = "/sign_in";
    static Task = '/task'
    static Task_Comment = '/task_comment'
    static Client = '/client'
    static ClientPOC = '/client-poc'
    static Group = '/group'
    static Project = '/project'
    static Link = '/link'
    static Project_Comment = '/project_comment'
    static Project_Contact_Type_List = '/project/contact_type_list'
    static Project_Type_List = '/project/project_type_list'
    static Project_closed_cancelled_reason = '/project_closed_cancelled_reason'
    static Project_Status = '/project_status'
    static Project_Plan = '/project_plan';
    static Project_Plan_Add_Bulk = '/project_plan/add_bulk';
    static WebsiteRequirement = '/website_requirements';
    static WebsiteRequirementDataField = '/website_requirements_data_field';
    static Question = '/question';
    static Question_types = '/question_type';
    static Cost_Approval_Process = '/cost_approval_process';
    static Cost_Approval_Process_Status = '/cost_approval_process/status_list';
    static Task_status = '/task_status'
    static User_group = '/user_group'
    static User = '/user'
    static Priority = '/task/priority_list'
    static masterSearch = '/master_search/fetch'
    static Country = '/country'
    static State = '/state'
    static City = '/city'
    static Client_Address = '/client_address'
    static Client_Address_Type = '/client_address/type_list'
    static Media = '/app_media'
    static History = '/history'
    static Event = '/event';
    static Submission_Product = '/submission_product';
    static Timezone = '/time_zone';
    static Payment_Type = '/payment_type';
    static Country_Code = '/country_code';    static Vendor = '/vendor';
    static Vendor_POC = '/vendor_poc';
    static Quotation = '/quotation_request';
    static Invoice = '/invoice';
    static Payment = '/payment';
    static AdvancePayment = '/advance_payment';
    static PaymentTransaction = '/payment_transaction';
    static PaymentAccountBank = '/payment_account_bank';
    static PaymentAccountCreditCard = '/payment_account_credit_card';
    static PaymentAccountUpi = '/payment_account_upi';
    static EventNotes = '/event_notes';
    static EventModerators = '/event_moderators';
    static EventMasterDashboardStats = '/event/stats';
    static EventDashboardEventTypeChart = '/event/type_stats';
    static EventDashboardEventUpcomingTrendChart = '/event/upcoming_trend';
    static EventDashboardStats = '/event/individual_stats?event={EVENT_ID}';
    static EventThumbnail = '/event/thumbnail?url='
    static Currency = '/currency'
    static CurrencyConverter = '/currency/converter?from_currency={FROM_CURRENCY}&to_currency={TO_CURRENCY}'
    static Event_Type = '/event/type_list'
    // New endpoint for filtered event types (keep legacy Event_Type as-is)
    static Event_Type_V2 = '/event_type'
    static Budget_Type = '/event/budget_type_list'
    static Event_Status = '/event/status_list'
    static EVENT_FORMAT_TYPES = '/event/event_format_list'

    static INDUSTRY = '/industry';

    // Outsorcing
    static OutsourcingType = '/outsourcing_type';
    static OutsourcingForm = '/outsourcing_form';
    static VendorSubmission = '/vendor_submission';
    static Tax = '/tax';
    static VendorAnswer = '/vendor_answer';
    static OutsourcingFormSection = '/outsourcing_form_section';
    static OutsourcingFormQuestion = '/outsourcing_form_question';
    static OutsourcingFormChoiceOption = '/outsourcing_form_choice_option';
    static OutsourcingEventRequest = '/outsourcing_event_request';
    static OutsourcingFormQuestionType = '/outsourcing_form_question/question_type_list';

    // Quatation
    static QuotationRequest = '/quotation_request'
    static OutsourcingRequestVendor = '/outsourcing_request_vendor'

    static DisplayOrderFormSection = '/outsourcing_form_section/modify_order';
    static DisplayOrderFormQuestion = '/outsourcing_form_question/modify_order';
    static DisplayOrderFormChoiceOption = '/outsourcing_form_choice_option/modify_order';

    // Sourcing Needs
    static SourcingNeed = '/sourcing_need';
    static SourcingEventType = '/sourcing_event_type';

    // SN venue
    static SourcingVenue = '/sourcing_venue';
    static SourcingVenueTypes = '/venue_type';
    static SourcingVenueRoomTypes = '/venue_room_type';
    static SourcingVenueSeatingStyle = '/venue_room_seating_arrangement';

    // SN - catering
    static SourcingCateging = '/catering';
    static CateringTypes = '/catering_type';
    static MealTypes = '/meal_type';
    static MealTiming = '/meal_timing';
    static NonAlcoholicBeverage = '/non_alcoholic_beverage';
    static AlcoholicBeverage = '/alcoholic_beverage';
    static DietaryPreferences = '/dietary_preferences';

    static ExperienceTypes = '/experience_type';
    static ExperienceCategory = '/experience_category';
    static ExperienceTestingType = '/experience_testing_type';
    static SourcingNeedExperienceSelection = '/sourcing_need_experience_selection';
    static SpeakerOnTalent = '/speaker';

    static AirportTransfers = '/airport_transfers';
    static LocalVenueTransfers = '/local_venue_transfers';
    static VehiclesTypes = '/vehicles_types';

    static transportRequirements = '/transport_requirements';

    static StageAccessories = '/stage_accessories';
    static GuestManagement = '/guest_management';
    static SignageBranding = '/signage_branding';
    static DemoEngagement = '/demo_engagement';
    static MediaAdvertising = '/media_advertising';
    static SetupBranding = '/setups_branding';
    static BrandingAndCollateral = '/branding_and_collateral';



    // Audio & Video
    static Microphones = '/microphones';
    static AudioEquipmentAudio = '/audio_equipment';
    static SupportInfra = '/support_infrastructure';
    static AvStaffing = '/av_staffing';
    static DisplayUnits = '/display_units';
    static CamerasAndRecording = '/cameras_recording';
    static StageLighting = '/general_stage_lighting';
    static VideoEquipments = '/video_equipment';
    static SpecialLighting = '/special_lighting';
    static LightingControl = '/lighting_control';
    static RiggingAndSupport = '/rigging_support';
    static SpeakerAndAudio = '/speakers_audio_output';
    static AvRequirements = '/av_requirements';

    // Production & Fabrication
    static ProductionAndFabrication = '/production_and_fabrication';
    static ProductionEventStructure = '/production_event_structure';
    static ProductionInfrastructure = '/production_infrastructure';
    static LiveStreamingHybrid = '/live_streaming_hybrid';
    static IntercomCommunication = '/intercom_communication';

    // Photo & Video
    static PhotoVideoRequirements = '/sourcing_need_photo_video';




    static DashboardStats = '/dashboard/stats';
    static DashboardTopUsers = '/dashboard/top_users';
    static DashboardProjectOverview = '/dashboard/project_overview';

    static UserReport = '/user_report';
    static TaskReport = '/task_report';
    static ProjectReport = '/project_report';
    static ClientReport = '/client_report';
    static MasterReport = '/master_report';

    static SettingUserTeamStats = '/user_group/stats';

    static tax_type = "/tax_type";
    static vendor_type = "/vendor_type";
    static vendor_tax = "/vendor_tax";
    static venueType = '/venue_type';
    static venue = '/venue';
    static venue_poc ='/venue_poc';
    static venue_room = '/venue_room';
    static venue_import = '/venue/upload'

    static venue_information = '/venue_information';

    static Event_vendor_feedback = '/event_vendor_feedback'
    static ExternalDeskFeedbackStore = '/external/desk_feedback_store'


    static Event_compliance = '/event_compliance';
    static License_type = '/license_type'
    static Vendor_Financial_Stats = '/vendor/financial_stats_v2';

    static Region = '/region';
    static Vertical = '/vertical';


}
